import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../utils/api';
import { useLanguage } from '../contexts/LanguageContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/auth');
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token via backend
        const response = await api.post('/auth/google/callback', { session_id: sessionId });
        
        if (response.data.token) {
          // Store JWT token (for backward compatibility with existing auth)
          localStorage.setItem('auth_token', response.data.token);
          
          // Clear the URL hash
          window.history.replaceState(null, '', window.location.pathname);
          
          // Navigate to dashboard with user data
          navigate('/dashboard', { state: { user: response.data.user } });
        } else {
          throw new Error('No token received');
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/auth', { state: { error: 'Google sign-in failed. Please try again.' } });
      }
    };

    processOAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#030305]">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#D4AF37] animate-spin mx-auto mb-4" />
        <p className="text-[#F8F5F2] font-sans">
          {language === 'tr' ? 'Giriş tamamlanıyor...' : 'Completing sign in...'}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
